export default __webpack_public_path__ + "static/media/62.5d210868.jpeg";